import * as React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function DropDownBranch({ data, setData, branches }) {
  const [branch, setBranch] = React.useState();

  const handleChange = (event) => {
     setData({ ...data, branch: event.target.value });
  };

  React.useEffect(() => {
    
    setBranch(data.branch);
  }, [data.branch]);

  return (
    <FormControl sx={{ width: 200 }}>
      <InputLabel id="select-basic" size="small">
        Branch
      </InputLabel>
      <Select
        labelId="select-basic"
        id="demo-simple-select"
        value={branch}
        label= "Branch"
        onChange={handleChange}
        size="small"
      >
        {branches.map((name) => (
          <MenuItem
            key={ name._id }
            value={ name._id }
          >
            {name.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
